import {combineReducers} from 'redux';

import user from './user';
import qna from './qna';
import analytics from './analytics';
import review from './review';
import brand from './brand';
import admin from './admin';
import order from './order';
import product from './product';
import log from './log';
import sample from './sample';
import design from './design';
import pgInfo from './pgInfo';
import setting from './setting';

// (이전상태, 액션) => 다음상태
const rootReducer = (state, action) => {
  switch (action.type) {
    default: {
      const combinedReducer = combineReducers({
        user,
        qna,
        analytics,
        review,
        brand,
        admin,
        order,
        product,
        log,
        sample,
        design,
        pgInfo,
        setting,
      });
      return combinedReducer(state, action);
    }
  }
};

export default rootReducer;
